define('get-learning',['helpers', 'fetch-local', 'fetch-offline', 'fetch-scorm', 'fetch-training'], function(helpers, fetchLocal, fetchOffline, fetchScorm, fetchTraining) {

    var getLearning = function(options) {
        options = options || {};

        var conf = {
                local: {
                    debugMode: options.debugMode,
                    trainingID: options.trainingID,
                    localStorage: options.localStorage
                },
                offline: {
                    debugMode: options.debugMode,
                    offlinePackage: options.offlinePackage
                },
                scorm: {
                    debugMode: options.debugMode,
                    scormProp: options.scormProp
                },
                training: {
                    classID: options.classID,
                    dataURL: options.dataURL,
                    debugMode: options.debugMode,
                    onLine: options.onLine,
                    previewMode: options.previewMode,
                    tokenID: options.tokenID,
                    trainingID: options.trainingID
                }
            },
            offlinePackage = options.offlinePackage,
            trainingID = options.trainingID;

        var setUserAnswers = function(training, userAnswers, scormPackage) {
            var entity,
                contentEntities = training.contentEntities,
                progress = scormPackage.progress;

            if (!progress.visited || !progress.answers) {
                return;
            }

            for (var i = 0; i < userAnswers.length; i++) {

                if (progress.visited.indexOf(i) !== -1) {
                    userAnswers[i].visited = true;
                }

                if (progress.answers[i]) {
                    entity = helpers.content.getEntity(userAnswers[i].contentEntityId, contentEntities);

                    if (!entity) {
                        continue;
                    }

                    userAnswers[i].answers = scormPackage.parseUserPattern(entity, progress.answers[i]);
                }

            }
        }

        return new Promise(function(resolve) {

            if (offlinePackage) {
                Promise.all([fetchScorm(conf.scorm), fetchOffline(conf.offline)]).then(function(arr) {
                    var scormPackage = arr[0] || {},
                        learning = arr[1] || {},
                        userID = '',
                        trainingID = '';

                    userID = (learning.user && learning.user.id) ? learning.user.id : '';
                    trainingID = (learning.training && learning.training.id) ? learning.training.id : '';

                    conf.local.userID = userID;
                    conf.local.trainingID = trainingID;

                    fetchLocal(conf.local).then(function(res) {

                        if (res.training) {
                            learning.training = res.training;
                        }

                        if (res.user && (!options.scormProp.enabled || scormPackage.entry !== 'ab-initio')) {
                            learning.user = res.user;
                        }

                        if (learning.user && learning.user.answers && options.scormProp.enabled && learning.training) {

                            setUserAnswers(learning.training, learning.user.answers, scormPackage);
                        }

                        if (res.lang) {
                            learning.lang = res.lang;
                        }

                        if (learning.user && scormPackage.lessonLocationID) {
                            learning.user.lastVisitedContentEntityId = (scormPackage.lessonLocationID) ? scormPackage.lessonLocationID : '';
                        }

                        resolve({
                            learning: learning,
                            trainingID: trainingID
                        });
                    });
                });
            } else {
                fetchLocal(conf.local).then(function(local) {

                    if (local.training && local.training.dateModified) {
                        conf.training.dateModified = local.training.dateModified;
                    }

                    fetchTraining(conf.training).then(function(learning) {

                        if (!learning.lang && local.lang) {
                            learning.lang = local.lang;
                        }

                        if (!learning.training && local.training) {
                            learning.training = local.training;
                        }

                        if (!learning.user && local.user) {
                            learning.user = local.user;
                        }

                        resolve({
                            learning: learning,
                            trainingID: trainingID
                        });

                    });

                });

            }
        });
    };

    return getLearning;
});

